import React, {Component} from 'react';
import {connect} from 'react-redux';
import {signIn} from '../../store/actions/authActions';
import {Redirect, NavLink} from 'react-router-dom';

class SignIn extends Component {
    state = {
        email: '',
        password: ''
    }

    handleChange = (e) => {
        this.setState({
            [e.target.id]: e.target.value
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this
            .props
            .signIn(this.state);
    }

    render() {
        const {authError, auth} = this.props;
        if (auth.uid) 
            return <Redirect to='/'/>

        return (
            <div className="valign-wrapper">
                <div className="valign full-width">
                    <div className="container">
                        <div className="row">
                            <div className="col s12 m6 offset-m3">
                                <div className="card">
                                    <div className="card-content">
                                        <h4>Sign In</h4>
                                        <p>Continue to BlogIt</p>
                                        <form onSubmit={this.handleSubmit}>
                                            <div className="input-field">
                                                <label htmlFor="email">Email</label>
                                                <input type="email" id="email" onChange={this.handleChange}/>
                                            </div>
                                            <div className="input-field">
                                                <label htmlFor="password">Password</label>
                                                <input type="password" id="password" onChange={this.handleChange}/>
                                            </div>
                                            <div className="input-field">
                                                <button className="btn waves-effect waves-light btn-login" type="submit">Login</button>
                                                <div className="red-text warning-text">
                                                    {authError
                                                        ? <p>{authError}</p>
                                                        : null}
                                                </div>
                                            </div>
                                        </form>
                                        <NavLink to="/signup" id="signupLink">Create account</NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {authError: state.auth.authError, auth: state.firebase.auth}
}

const mapDispatchToProps = (dispatch) => {
    return {
        signIn: (credentials) => dispatch(signIn(credentials))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SignIn);